<div *ngIf="loading" class="tec-loading">
  <mat-spinner></mat-spinner>
</div>
